<template>
  <div>
    <success :success="success"/>

    <form class="login" @submit.prevent="send_email" v-if="!success">
      <login-card header-color="green">
        <h4 slot="title" class="card-title">Востановление пароля</h4>

        <error slot="description" :errors="errors"/>

        <md-field class="md-form-group" slot="inputs" v-for="(input, key) in auth" :key="key">
          <md-icon>{{ input.icon }}</md-icon>
          <label>{{ input.label }}</label>
          <md-input v-model="input.value" :type="input.type"></md-input>
        </md-field>

        <md-button slot="footer" class="md-simple md-success md-lg" type="submit">
          Ок
        </md-button>

      </login-card>

    </form>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import { LoginCard } from "@/components"
import Error from "./Error"
import Success from "./Success"

export default {
  name: "RestorePassword",
  components: {Success, LoginCard, Error},
  data(){
    return {
      auth: {
        email: {
          label: 'Ваш email адресс',
          value: '',
          type: 'email',
          icon: 'alternate_email',
        }
      },
      errors: [],
      success: null
    }
  },
  methods: {
    ...mapActions(["auth/restore_password"]),
    send_email() {
      let email = this.auth.email.value;
      this.$store.dispatch('auth/restore_password', { email })
          .then((response) => {
            this.errors = [];
            this.success = response;
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else {
              this.errors.push(err.message);
            }
          })
    }
  }
}

</script>

<style scoped>

</style>